const Emb = {
  symbol: 'emb',
  color: '#000',
  colorIcon() {
    return `<g fill="none"><circle fill="#F6C054" cx="16" cy="16" r="16"/><path d="M26.822 15.568l-10.39-10.39a.607.607 0 00-.86 0L5.18 15.569a.607.607 0 000 .86l10.39 10.393a.607.607 0 00.859 0l10.39-10.389a.608.608 0 00.004-.864zm-2.284.52l-7.616 7.616V16h-1.848v7.704l-7.616-7.616a.12.12 0 010-.172l8.454-8.453a.12.12 0 01.172 0l8.454 8.453a.12.12 0 010 .172c0-.004 0-.004 0 0z" fill="#FFF"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-.343 5.108l-.084.07-10.394 10.39a.607.607 0 00-.071.775l.07.085 10.39 10.393a.607.607 0 00.776.071l.084-.07 10.39-10.39a.608.608 0 00.004-.864l-10.39-10.39a.607.607 0 00-.775-.07zm.387 2.328l.04.027 8.454 8.453a.117.117 0 01.027.131l-.027.041-7.616 7.616V16h-1.848v7.704l-7.616-7.616a.12.12 0 01-.027-.131l.027-.04 8.454-8.454a.12.12 0 01.132-.027z"/>`;
  }
};
export default Emb;
